/**
 * Per-route SEO metadata — single source of truth, consumed BOTH by <SeoHead>
 * at runtime (client) AND by the build-time prerender (scripts/prerender.mjs) so
 * the static HTML head and the client head stay identical (no drift).
 */
export interface RouteSeo {
  title: string
  description?: string
  canonicalPath?: string
  noindex?: boolean
}

export const ROUTE_SEO = {
  '/': {
    title: 'Corsalia : jeu de stratégie maritime asynchrone, sans pay-to-win',
    description:
      "Corsalia, jeu de stratégie maritime asynchrone et sans pay-to-win : bâtis ton île, arme ta flotte et forge ta réputation dans l'archipel, à ton rythme.",
    canonicalPath: '/',
  },
  '/codex': {
    title: 'Codex Corsalia : toutes les règles du jeu corsaire',
    description:
      'Toutes les règles de Corsalia : combat, économie, flotte, réputation, Forge, missions. Jeu de gestion maritime asynchrone, sans pay-to-win.',
    canonicalPath: '/codex',
  },
  '/nouveautes': {
    title: 'Nouveautés Corsalia : le journal de bord de l’archipel',
    description:
      "Les annonces de Corsalia : bilans de saison, nouveautés livrées et ce qui se prépare. Jeu de stratégie maritime asynchrone, sans pay-to-win.",
    canonicalPath: '/nouveautes',
  },
  '/legal': {
    title: 'Mentions légales · Corsalia',
    noindex: true,
  },
} satisfies Record<string, RouteSeo>
